import { screen } from 'components/styles/variables';

export default `
  .scrolling-container {
    overflow-y: auto;
  }

  @media (min-width: ${screen.mobileMax}) {
    .scrolling-container {
      height: calc(70vh - 60px);
      max-height: 465px;
      min-height: 200px;
      overflow-y: auto;
    }
  }
`;
